import { useContext } from 'react'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { EntryKeyContext } from '../../context/EntryKeyContext'
import { ToggleButton } from './components/ToggleButton/index'
import * as S from './styled'

const SwitchFilter = ({ children, optionClick = { name: '' } }) => {
  const { onOptionClick, query } = useContext(EntryKeyContext)

  return (
    <S.SwitchFilter>
      <Text as="strong" size="giga" bold noMargin>
        {children}
      </Text>

      <ToggleButton
        isActive={Boolean(query?.[optionClick.name])}
        onClick={event => {
          event.preventDefault()
          event.stopPropagation()

          onOptionClick({ ...optionClick })
        }}
      />
    </S.SwitchFilter>
  )
}

export default SwitchFilter
